import type { ReactNode, SVGProps } from "react";

export function PDFFileIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 14 16"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.8252 0.625V3.825C7.8252 4.03717 7.90948 4.24066 8.05951 4.39069C8.20954 4.54071 8.41302 4.625 8.6252 4.625H11.8252"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 7.825V2.225C0.625 1.80065 0.793571 1.39369 1.09363 1.09363C1.39369 0.793571 1.80065 0.625 2.225 0.625H7.825L11.825 4.625V7.825"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 12.6249H1.825C2.14326 12.6249 2.44848 12.4984 2.67353 12.2734C2.89857 12.0483 3.025 11.7431 3.025 11.4249C3.025 11.1066 2.89857 10.8014 2.67353 10.5763C2.44848 10.3513 2.14326 10.2249 1.825 10.2249H0.625V15.0249"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M10.2251 12.625H11.8251"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M12.6251 10.2249H10.2251V15.0249"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M5.4248 10.2249V15.0249H6.2248C6.64915 15.0249 7.05612 14.8563 7.35618 14.5562C7.65623 14.2562 7.8248 13.8492 7.8248 13.4249V11.8249C7.8248 11.4005 7.65623 10.9935 7.35618 10.6935C7.05612 10.3934 6.64915 10.2249 6.2248 10.2249H5.4248Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
